module.exports = __webpack_public_path__ + "archivist_noia.gif?878facb12dad1635e33235f1dc70c363";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_noia.gif
// module id = 370
// module chunks = 0